import ProductLanding from './ProductLanding.vue'

export default ProductLanding
